/**
 * @generated SignedSource<<d54ecdba3a4fc8993248a556fe38c8bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectSidePanelNotes_user$data = {
  readonly id: number;
  readonly " $fragmentType": "ProjectSidePanelNotes_user";
};
export type ProjectSidePanelNotes_user$key = {
  readonly " $data"?: ProjectSidePanelNotes_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSidePanelNotes_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectSidePanelNotes_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "ffc4130d3af18df65dd2fa3bdb716b54";

export default node;
